import { Route } from "react-router-dom";
import ClientChatList from "../components/index";
import ClientChat from "../../client-chat/components/index";
import DefaultClientChat from "../../client-chat/components/DefualtChat";
import ClientMiddleware from "../../client-middleware/components/index";

const ClientChatListRoutes = () => (
  <>
    <Route path="/client/chat/:type" element={<ClientMiddleware><ClientChatList /></ClientMiddleware>}>
      <Route index element={<DefaultClientChat />} />
      <Route path=":id/:chatId?" element={<ClientChat />} />
    </Route>
  </>
);

export default ClientChatListRoutes;
